import React from "react";
import { logUserOut } from "../../helper-functions/api/authQueries";

export default function LogOut(props) {
    React.useEffect(() => {
        logUserOut(props);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
